import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormulaireNouveauComponent } from './formulaire-nouveau/formulaire-nouveau.component';
import { FormulairePretComponent } from './formulaire-pret/formulaire-pret.component';
import { ConnexionComponent } from './connexion/connexion.component';
import { MentionsLegalesComponent } from './mentions-legales/mentions-legales.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PageForbiddenComponent } from './page-forbidden/page-forbidden.component';

import { FormContactGuard } from './form-contact-guard.service';
import { ConnexionGuard } from './connexion-guard.service';

const routes: Routes = [
  { path: '', redirectTo: '/formulaire/pret', pathMatch: 'full' },
  { path: 'formulaire/nouveau', component: FormulaireNouveauComponent, canActivate: [ConnexionGuard] },
  { path: 'formulaire/pret', component: FormulairePretComponent, canActivate: [ConnexionGuard] },
  { path: 'connexion', component: ConnexionComponent },
  { path: 'mentions-legales', component: MentionsLegalesComponent, canActivate: [ConnexionGuard] },
  { path: 'interdit', component: PageForbiddenComponent },
  { path: '**', component: PageNotFoundComponent, canActivate: [ConnexionGuard] }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts